import { defineComponent as v, watchEffect as S, onMounted as y, h as a, renderSlot as _ } from "vue";
import { getMonthString as g, getQuarterString as b, getYearString as $ } from "./ghl-ui.es964.js";
import { MONTH_ITEM_HEIGHT as m } from "./ghl-ui.es1319.js";
import { useDualCalendarProps as k, useDualCalendar as O } from "./ghl-ui.es1344.js";
import { warnOnce as C } from "./ghl-ui.es853.js";
import R from "./ghl-ui.es919.js";
import u from "./ghl-ui.es994.js";
import f from "./ghl-ui.es215.js";
import { XButton as p } from "./ghl-ui.es253.js";
import M from "./ghl-ui.es1147.js";
const B = v({
  name: "MonthRangePanel",
  props: Object.assign(Object.assign({}, k), {
    type: {
      type: String,
      required: !0
    }
  }),
  setup(o) {
    process.env.NODE_ENV !== "production" && S(() => {
      var e;
      !((e = o.actions) === null || e === void 0) && e.includes("now") && C("date-picker", `The \`now\` action is not supported for n-date-picker of ${o.type}type`);
    });
    const s = O(o, o.type), {
      dateLocaleRef: i
    } = R("DatePicker"), t = (e, d, r, c) => {
      const {
        handleColItemClick: h
      } = s, n = !1;
      return a("div", {
        "data-n-date": !0,
        key: d,
        class: [`${r}-date-panel-month-calendar__picker-col-item`, e.isCurrent && `${r}-date-panel-month-calendar__picker-col-item--current`, e.selected && `${r}-date-panel-month-calendar__picker-col-item--selected`, n],
        onClick: () => {
          h(e, c);
        }
      }, e.type === "month" ? g(e.dateObject.month, e.monthFormat, i.value.locale) : e.type === "quarter" ? b(e.dateObject.quarter, e.quarterFormat, i.value.locale) : $(e.dateObject.year, e.yearFormat, i.value.locale));
    };
    return y(() => {
      s.justifyColumnsScrollState();
    }), Object.assign(Object.assign({}, s), {
      renderItem: t
    });
  },
  render() {
    var o, s, i;
    const {
      mergedClsPrefix: t,
      mergedTheme: e,
      shortcuts: d,
      type: r,
      renderItem: c,
      onRender: h
    } = this;
    return h == null || h(), a("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${t}-date-panel`, `${t}-date-panel--daterange`, !this.panel && `${t}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, a("div", {
      ref: "startDatesElRef",
      class: `${t}-date-panel-calendar ${t}-date-panel-calendar--start`
    }, a("div", {
      class: `${t}-date-panel-month-calendar`
    }, a(u, {
      ref: "startYearScrollbarRef",
      class: `${t}-date-panel-month-calendar__picker-col`,
      theme: e.peers.Scrollbar,
      themeOverrides: e.peerOverrides.Scrollbar,
      container: () => this.virtualListContainer("start"),
      content: () => this.virtualListContent("start"),
      horizontalRailStyle: {
        zIndex: 1
      },
      verticalRailStyle: {
        zIndex: 1
      }
    }, {
      default: () => a(f, {
        ref: "startYearVlRef",
        items: this.startYearArray,
        itemSize: m,
        showScrollbar: !1,
        keyField: "ts",
        onScroll: this.handleStartYearVlScroll,
        paddingBottom: 4
      }, {
        default: ({
          item: n,
          index: l
        }) => c(n, l, t, "start")
      })
    }), r === "monthrange" || r === "quarterrange" ? a("div", {
      class: `${t}-date-panel-month-calendar__picker-col`
    }, a(u, {
      ref: "startMonthScrollbarRef",
      theme: e.peers.Scrollbar,
      themeOverrides: e.peerOverrides.Scrollbar
    }, {
      default: () => [(r === "monthrange" ? this.startMonthArray : this.startQuarterArray).map((n, l) => c(n, l, t, "start")), r === "monthrange" && a("div", {
        class: `${t}-date-panel-month-calendar__padding`
      })]
    })) : null)), a("div", {
      class: `${t}-date-panel__vertical-divider`
    }), a("div", {
      ref: "endDatesElRef",
      class: `${t}-date-panel-calendar ${t}-date-panel-calendar--end`
    }, a("div", {
      class: `${t}-date-panel-month-calendar`
    }, a(u, {
      ref: "endYearScrollbarRef",
      class: `${t}-date-panel-month-calendar__picker-col`,
      theme: e.peers.Scrollbar,
      themeOverrides: e.peerOverrides.Scrollbar,
      container: () => this.virtualListContainer("end"),
      content: () => this.virtualListContent("end"),
      horizontalRailStyle: {
        zIndex: 1
      },
      verticalRailStyle: {
        zIndex: 1
      }
    }, {
      default: () => a(f, {
        ref: "endYearVlRef",
        items: this.endYearArray,
        itemSize: m,
        showScrollbar: !1,
        keyField: "ts",
        onScroll: this.handleEndYearVlScroll,
        paddingBottom: 4
      }, {
        default: ({
          item: n,
          index: l
        }) => c(n, l, t, "end")
      })
    }), r === "monthrange" || r === "quarterrange" ? a("div", {
      class: `${t}-date-panel-month-calendar__picker-col`
    }, a(u, {
      ref: "endMonthScrollbarRef",
      theme: e.peers.Scrollbar,
      themeOverrides: e.peerOverrides.Scrollbar
    }, {
      default: () => [(r === "monthrange" ? this.endMonthArray : this.endQuarterArray).map((n, l) => c(n, l, t, "end")), r === "monthrange" && a("div", {
        class: `${t}-date-panel-month-calendar__padding`
      })]
    })) : null)), this.datePickerSlots.footer ? a("div", {
      class: `${t}-date-panel-footer`
    }, _(this.datePickerSlots, "footer")) : null, !((o = this.actions) === null || o === void 0) && o.length || d ? a("div", {
      class: `${t}-date-panel-actions`
    }, a("div", {
      class: `${t}-date-panel-actions__prefix`
    }, d && Object.keys(d).map((n) => {
      const l = d[n];
      return Array.isArray(l) || typeof l == "function" ? a(p, {
        size: "tiny",
        onMouseenter: () => {
          this.handleRangeShortcutMouseenter(l);
        },
        onClick: () => {
          this.handleRangeShortcutClick(l);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => n
      }) : null;
    })), a("div", {
      class: `${t}-date-panel-actions__suffix`
    }, !((s = this.actions) === null || s === void 0) && s.includes("clear") ? a(p, {
      theme: e.peers.Button,
      themeOverrides: e.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    }) : null, !((i = this.actions) === null || i === void 0) && i.includes("confirm") ? a(p, {
      theme: e.peers.Button,
      themeOverrides: e.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isRangeInvalid,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    }) : null)) : null, a(M, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  B as default
};
